<script setup lang="ts">
import type { PostDeep } from '@blog/types'

defineProps<{
  post: PostDeep
  crypto?: boolean
}>()
</script>

<template>
  <nuxt-link :to="`/${crypto ? 'o-kryptomenach-post' : 'blog-post'}/${post.slug}`" w-full>
    <div fubex-rounded-lg border border-neutral-300 flex flex-col md:flex-row gap-16px lg:max-w-970px hover="bg-neutral-50 fubex-shadow-md-down scale-103" transition-all duration-250 class="group">
      <div relative>
        <div lg:w-342px min-w-300px overflow-clip rounded-b-0 md:rounded-b-16px md:rounded-r-0 fubex-rounded-lg>
          <NuxtImg :src="directusImg(post!.featured_image!, 'bitbeli-md')" :alt="post.slug" h-auto w-full object-cover saturate-70 group-hover="saturate-100" duration-500 />
        </div>
        <div v-if="!crypto" flex gap-8px absolute bottom-2 left-2>
          <BlogTag v-for="item in post.tags" :key="item.bitbeli_tag_slug.slug" :tag="item.bitbeli_tag_slug" :reverse="true" />
        </div>
      </div>
      <div md:py-24px px-12px pb-16px flex flex-col gap-8px md:max-w-400px lg:max-w-500px w-full>
        <div w-full>
          <h2 heading5 font-700 text-neutral-900 md:line-clamp-2>
            {{ post.title }}
          </h2>
        </div>
        <div w-full>
          <div flex gap-8px items-center mb-4px>
            <NuxtImg :src="directusImg(post.author.avatar, 'bitbeli-sm') ?? 'https://placehold.co/85x85'" alt="" rounded-full w-30px h-30px />
            <h5 text-sm text-neutral-900>
              {{ post.author.title }}
            </h5>
            <h6 text-xs text-neutral-400>
              {{ formatDateTime(post.date_published, true) }}
            </h6>
          </div>
          <h3 paragraph-md text-neutral-500 line-clamp="lg:2 3">
            <span v-html="post.perex" />
          </h3>
        </div>
      </div>
    </div>
  </nuxt-link>
</template>
